import { render, staticRenderFns } from "./v_Ongoing.vue?vue&type=template&id=4cb9b1a1&scoped=true&"
import script from "./v_Ongoing.vue?vue&type=script&lang=js&"
export * from "./v_Ongoing.vue?vue&type=script&lang=js&"
import style0 from "./v_Ongoing.vue?vue&type=style&index=0&id=4cb9b1a1&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cb9b1a1",
  null
  
)

export default component.exports